/**
 * Permission catalogue (SRS §3.1). Code checks permissions, never role names (EXT-2).
 * Strings are namespaced `<area>.<action>[.<scope>]`; future modules add their own namespace.
 */
export const PERMISSIONS = [
    'self.read',
    'self.update.personal',
    'self.update.contact',
    'self.update.emergency',
    'self.request.bank',
    'team.read',
    'employee.read.all',
    'employee.create',
    'employee.update.all',
    'salary.read.all',
    'sensitive.read.all',
    'salary.write',
    'bank.approve',
    'lookup.manage',
    'export.run',
    'role.manage',
    'audit.read',
    'settings.manage',
    // Password sign-in (v1.3, ADR-091): send / resend set-password links (FR-AUTH-15)
    'account.invite',
    // Payroll (M6, SRS §12, AC-8)
    'payroll.read',
    'payroll.prepare',
    'payroll.approve',
    'payroll.disburse',
    'payroll.tax.manage',
    'payroll.settings',
    // Leave (M7, SRS §13)
    'leave.request',
    'leave.read.all',
    'leave.manage',
    // Attendance & WFH (M7, SRS §14–§15)
    'attendance.checkin',
    'attendance.regularise',
    'attendance.read.all',
    'attendance.manage',
    'wfh.request',
    // Work calendar (SRS §16)
    'calendar.manage',
];
/** Constant accessors, e.g. `Permission.SALARY_READ_ALL === 'salary.read.all'`. */
export const Permission = {
    SELF_READ: 'self.read',
    SELF_UPDATE_PERSONAL: 'self.update.personal',
    SELF_UPDATE_CONTACT: 'self.update.contact',
    SELF_UPDATE_EMERGENCY: 'self.update.emergency',
    SELF_REQUEST_BANK: 'self.request.bank',
    TEAM_READ: 'team.read',
    EMPLOYEE_READ_ALL: 'employee.read.all',
    EMPLOYEE_CREATE: 'employee.create',
    EMPLOYEE_UPDATE_ALL: 'employee.update.all',
    SALARY_READ_ALL: 'salary.read.all',
    SENSITIVE_READ_ALL: 'sensitive.read.all',
    SALARY_WRITE: 'salary.write',
    BANK_APPROVE: 'bank.approve',
    LOOKUP_MANAGE: 'lookup.manage',
    EXPORT_RUN: 'export.run',
    ROLE_MANAGE: 'role.manage',
    AUDIT_READ: 'audit.read',
    SETTINGS_MANAGE: 'settings.manage',
    ACCOUNT_INVITE: 'account.invite',
    PAYROLL_READ: 'payroll.read',
    PAYROLL_PREPARE: 'payroll.prepare',
    PAYROLL_APPROVE: 'payroll.approve',
    PAYROLL_DISBURSE: 'payroll.disburse',
    PAYROLL_TAX_MANAGE: 'payroll.tax.manage',
    PAYROLL_SETTINGS: 'payroll.settings',
    LEAVE_REQUEST: 'leave.request',
    LEAVE_READ_ALL: 'leave.read.all',
    LEAVE_MANAGE: 'leave.manage',
    ATTENDANCE_CHECKIN: 'attendance.checkin',
    ATTENDANCE_REGULARISE: 'attendance.regularise',
    ATTENDANCE_READ_ALL: 'attendance.read.all',
    ATTENDANCE_MANAGE: 'attendance.manage',
    WFH_REQUEST: 'wfh.request',
    CALENDAR_MANAGE: 'calendar.manage',
};
export function isPermission(value) {
    return PERMISSIONS.includes(value);
}
//# sourceMappingURL=permissions.js.map